import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Container,
  HelpMenuBar,
  Item,
  ItemLink,
  ListItens,
  MenuContainer,
  Wrapper,
} from "./index.styled";
import { IoHelpOutline } from "react-icons/io5";
import useRootTranslation from "../../../hooks/use-root-translation";

export const Helper: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const { root } = useRootTranslation('helper.itens' ,'private-home-page');

  useEffect(() => {
    function handleClickOutside(ev: MouseEvent) {
      if (
        menuRef.current &&
        ev.target instanceof Node &&
        !menuRef.current.contains(ev.target)
      ) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuRef]);

  const findDev = useCallback(() => {
    const params = new URLSearchParams("career=1b73eec2-c27b-4820-8e79-8238c93a5224&ecosystem=ad63a367-a5e5-47b6-a9bf-0a6dfb5fe1ff&forceTour=true")
    window.location.href = `/ranking?${params.toString()}`;
  }, []);

  return (
    <Wrapper>
      <Container
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <IoHelpOutline />
      </Container>
      <HelpMenuBar ref={menuRef}>
        {isOpen && (
          <MenuContainer>
            <ListItens>
            <Item>
                <ItemLink
                  onClick={() => {
                    setIsOpen(false);
                    findDev();
                  }}
                >
                  {root('find-talent')}
                </ItemLink>
              </Item>
            </ListItens>
          </MenuContainer>
        )}
      </HelpMenuBar>
    </Wrapper>
  );
};
